export default "__VITE_ASSET__BMXsEgZQ__"